module.exports = __webpack_public_path__ + "img/VehiculoDatos.6993e38f.svg";